import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

export const set = property => (state, payload) => (state[property] = payload)
export const toggle = property => state => (state[property] = !state[property])

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'my-app',
  storage: window.localStorage
})

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    authenticated: null,
    permissions: [],
    drawer: null,
    responsive: true,
    color: 'success',
    cpf: "",
    email: "",
    nomeUsuario: "",
    passaporte: "",
    unidades: "",
  },
  mutations: {
    setDrawer: set('drawer'),
    setImage: set('image'),
    setColor: set('color'),
    toggleDrawer: toggle('drawer'),
    setResponsive: set('responsive'),
    setPermissions: set('permissions'),
    setUnidades: set('unidades'),
    setAuthenticated: set('authenticated'),
    setNomeUsuario: set('nomeUsuario'),
    setPassaporte: set('passaporte'),
    setToken: set('token'),
    setEmail: set('email'),
    setCpf: set('cpf'),
    setUserId: set('userId'),

  },
  actions: {
    login(context, redirectPath) {
      // eslint-disable-next-line no-undef
      let appPublicPath = process.env.VUE_APP_PUBLIC_PATH;
      if (appPublicPath === undefined || redirectPath.split("/")[1] === 'projetos-simplifica') {
        appPublicPath = "";
      }
      const apiUri =
          location.origin +
          appPublicPath +
          redirectPath;

      // eslint-disable-next-line no-undef
      keycloak.login({
        locale: "pt-br",
        kcLocale: "pt-br",
        redirectUri: apiUri,
      });
    },
    async logout(context) {
      // eslint-disable-next-line no-undef
      if (!keycloak.authenticated) {
        context.commit("setAuthenticated", false);
        context.commit("setPermissions", []);
        context.commit("setNomeUsuario", "");
        context.commit("setEmail", "");
        context.commit("setCpf", "");
        context.commit("setPassaporte", "");
        context.commit("setToken", "");
        context.commit("setUserId", null);
      } else {
        let redirectUri = process.env.VUE_APP_PUBLIC_PATH;
        if (!redirectUri){
          redirectUri = "";
        }
        keycloak.logout({
          redirectUri: location.origin + "/" + redirectUri
        });
      }
    },
    async getInfo(context) {
      const info = await keycloak.loadUserInfo();
      //const profile = await keycloak.loadUserProfile();
      let papeis = info.papeis ? info.papeis : null;
      if (papeis == null && info.resource_access
          && info.resource_access["projetos-simplifica"]
          && info.resource_access["projetos-simplifica"].roles)
      {
          papeis = info.resource_access["projetos-simplifica"].roles
      }
      if (papeis) {
        papeis.push('LOGADO')
      } else {
        papeis = ['LOGADO']
      }
      let uas = null;
      papeis = papeis.concat(papeis.join('@@').toLowerCase().split('@@'));
      papeis = [...new Set(papeis)];
      context.commit("setAuthenticated", keycloak.authenticated);
      context.commit("setPermissions", papeis);
      context.commit("setUnidades", uas);
      context.commit("setNomeUsuario", info.name);
      context.commit("setEmail", info.email);
      context.commit("setCpf", info.cpf);
      context.commit("setPassaporte", info.preferred_username);
      context.commit("setToken", keycloak.token);
      context.commit("setUserId", info.sub);
    },
  }
})
